import type { IVariant, Variant } from './variant';

export interface IFlag {
	createdAt: Date;
	description: string;
	enabled: boolean;
	expiresAt: Date;
	name: string;
	service: string;
	variants: IVariant[];
}

export class Flag implements IFlag {
	public createdAt: Date;
	public description: string;
	public enabled: boolean;
	public expiresAt: Date;
	public name: string;
	public service: string;
	public variants: Variant[];
	public constructor({ createdAt, description, enabled, expiresAt, name, service, variants }: IFlag) {
		this.createdAt = createdAt;
		this.description = description;
		this.enabled = enabled;
		this.expiresAt = expiresAt;
		this.name = name;
		this.service = service;
		this.variants = variants;
	}
}
